export default "__VITE_ASSET__BMTaiC6E__"